/* eslint-disable react/jsx-props-no-spreading */

import _ from 'lodash'
import React from 'react'
import { useCurrencies } from '../../vendor/react-omnitech-api'
import CurrencyFormatView from './currency-format-view'

const CurrencyFormatController = (props) => {
  const {
    currencyCode,
    currency: currencyOverride,
    ...others
  } = props
  const { currencies } = useCurrencies()
  let currency = _.find(currencies, { isBaseCurrency: true })
  if (!_.isEmpty(currencyCode)) {
    currency = _.find(currencies, { code: currencyCode }) || currency
  }
  if (!_.isEmpty(currencyOverride)) {
    currency = currencyOverride
  }
  return !_.isEmpty(currency) ? <CurrencyFormatView currency={currency} {...others} /> : null
}

export default CurrencyFormatController
